import Script from 'next/script'
import { getAppConfig } from '@/config/config'
import AppContext from '@/types/context'
import { FeatureFlagService } from '@/services/api/unleash/FeatureFlag.service'
import { FF_WEBPUSH } from '@/config/featureFlags'

const publicRuntimeConfig = getAppConfig()
const basePath = publicRuntimeConfig.basePath

export default function Webpush({ context }: { context: AppContext }) {
  return (
    !context.webview &&
    FeatureFlagService.isFeatureFlagEnabled(context.featureFlags, FF_WEBPUSH) && (
      <Script
        src={`${basePath}/scripts/webpush/webpush.js`}
        strategy="afterInteractive"
        onLoad={() => console.log('[Webpush] loaded webpush script')}
        onError={(error) => console.error('[Webpush] Error while loading webpush script', error)}
      />
    )
  )
}
